// src/services/auth.js
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const authApi = createApi({
  reducerPath: "auth",
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_BACKEND_URL}/api/auth/`,
    prepareHeaders: (headers, { getState }) => {
      const token = localStorage.getItem("token");
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),
  tagTypes: ["Auth"],
  endpoints: (builder) => ({
    signup: builder.mutation({
      query: (formData) => ({
        url: "signup",
        method: "POST",
        body: formData,
      }),
    }),
    login: builder.mutation({
      query: (formData) => ({
        url: "login",
        method: "POST",
        body: formData,
      }),
    }),
    genAppLogin: builder.mutation({
      query: (formData) => ({
        url: "gen-app-login",
        method: "POST",
        body: formData,
      }),
    }),
    signupUser: builder.mutation({
      query: (userDetails) => ({
        url: "signup",
        method: "POST",
        body: userDetails,
      }),
    }),
    forgotPassword: builder.mutation({
      query: (email) => ({
        url: "forgot-password",
        method: "POST",
        body: { email },
      }),
    }),
    changePassword: builder.mutation({
      query: ({ userId, currentPassword, newPassword }) => ({
        url: "change-password",
        method: "POST",
        body: { userId, currentPassword, newPassword },
      }),
    }),
  }),
});

export const {
  useSignupMutation,
  useLoginMutation,
  useGenAppLoginMutation,
  useSignupUserMutation,
  useForgotPasswordMutation,
  useChangePasswordMutation,
} = authApi;

export default authApi;
export { authApi };
